module.exports = __webpack_public_path__ + "static/media/Element_Anemo.3564b159.png";